import { Link } from "wouter";
import { ArrowLeft } from "lucide-react";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function Privacy() {
  usePageMeta({
    title: "プライバシーポリシー | Biz-AI検定",
    description: "Biz-AI検定のプライバシーポリシー。個人情報の取り扱いについて説明しています。",
  });

  return (
    <div className="min-h-screen bg-[#faf6ee]">
      <header className="border-b border-[#c9bca7]/50 bg-[#f9f4e8]">
        <div className="max-w-3xl mx-auto px-6 py-4">
          <Link href="/" className="inline-flex items-center text-sm text-[#675a49] hover:text-[#2f1d15] transition-colors">
            <ArrowLeft className="w-4 h-4 mr-1" />
            トップに戻る
          </Link>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-6 py-12">
        <h1 className="text-2xl font-bold text-[#4e2b1f] mb-8">プライバシーポリシー</h1>

        <div className="space-y-8 text-[15px] text-[#4e2b1f] leading-relaxed">
          <p>
            合同会社AIM（以下「当社」）は、Biz-AI検定試験サービス（以下「本サービス」）における利用者の個人情報の取扱いについて、
            以下のとおりプライバシーポリシーを定めます。
          </p>

          <section>
            <h2 className="text-lg font-semibold text-[#4e2b1f] mb-3">1. 収集する個人情報</h2>
            <p className="mb-2">当社は、本サービスの提供にあたり、以下の個人情報を収集することがあります。</p>
            <ul className="list-disc list-inside space-y-1">
              <li>氏名</li>
              <li>メールアドレス</li>
              <li>試験の受験履歴および成績情報</li>
              <li>決済に関する情報（クレジットカード情報は決済代行会社Stripeが管理し、当社は保持しません）</li>
              <li>アクセスログ、Cookie情報</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#4e2b1f] mb-3">2. 個人情報の利用目的</h2>
            <p className="mb-2">収集した個人情報は、以下の目的で利用します。</p>
            <ul className="list-disc list-inside space-y-1">
              <li>本サービスの提供および運営</li>
              <li>試験結果の通知、資格認定証の発行</li>
              <li>受験料の決済処理</li>
              <li>お問い合わせへの対応</li>
              <li>サービスの改善および新機能の開発</li>
              <li>重要なお知らせやサービスに関する通知の送信</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#4e2b1f] mb-3">3. 個人情報の第三者提供</h2>
            <p>
              当社は、以下の場合を除き、利用者の個人情報を第三者に提供することはありません。
            </p>
            <ul className="list-disc list-inside space-y-1 mt-2">
              <li>利用者の同意がある場合</li>
              <li>法令に基づく場合</li>
              <li>人の生命、身体または財産の保護のために必要がある場合</li>
              <li>サービスの提供に必要な範囲で業務委託先に提供する場合（決済代行等）</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#4e2b1f] mb-3">4. 個人情報の管理</h2>
            <p>
              当社は、個人情報の漏洩、滅失またはき損の防止のために、適切なセキュリティ対策を講じます。
              クレジットカード情報の処理はPCI DSS準拠の決済代行会社（Stripe）を通じて行い、当社のサーバーにカード情報を保存することはありません。
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#4e2b1f] mb-3">5. Cookieの使用</h2>
            <p>
              本サービスでは、利用者の認証状態の維持およびサービスの利便性向上のためにCookieを使用しています。
              ブラウザの設定によりCookieを無効にすることも可能ですが、その場合一部の機能をご利用いただけない場合があります。
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#4e2b1f] mb-3">6. 個人情報の開示・訂正・削除</h2>
            <p>
              利用者は、当社が保有する自己の個人情報について、開示・訂正・削除を請求することができます。
              ご希望の方は、下記のお問い合わせ先までご連絡ください。
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#4e2b1f] mb-3">7. プライバシーポリシーの変更</h2>
            <p>
              当社は、必要に応じて本ポリシーを変更することがあります。
              変更後のポリシーは、本サービス上に掲載した時点から効力を生じるものとします。
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-[#4e2b1f] mb-3">8. お問い合わせ先</h2>
            <dl className="space-y-2">
              <div>
                <dt className="text-sm text-[#8e7f69]">事業者</dt>
                <dd>合同会社AIM</dd>
              </div>
              <div>
                <dt className="text-sm text-[#8e7f69]">メールアドレス</dt>
                <dd>info@aim-llc.jp</dd>
              </div>
            </dl>
          </section>

          <div className="pt-4 text-sm text-[#8e7f69]">
            <p>制定日：2026年3月13日</p>
          </div>
        </div>
      </main>

      <footer className="border-t border-[#c9bca7]/50 py-8 px-6 bg-[#f9f4e8]">
        <div className="max-w-3xl mx-auto">
          <p className="text-[12px] text-[#8e7f69]">&copy; 2026 Biz-AI</p>
        </div>
      </footer>
    </div>
  );
}
